/* hero carousel */
(function () {
  'use strict';

  var ROOT = '[data-yg-hero-carousel]';
  var instances = {};

  var DRAG_THRESHOLD = 5;
  var COMMIT_RATIO = 0.5;
  var QUICK_MS = 300;
  var TAP_SLOP = 20;
  var COOLDOWN_BUFFER = 120;

  function matches(query) {
    return !!(window.matchMedia && window.matchMedia(query).matches);
  }

  function currentX(el) {
    var value = window.getComputedStyle(el).transform;
    if (!value || value === 'none') return 0;
    var open = value.indexOf('(');
    var close = value.lastIndexOf(')');
    if (open < 0 || close < 0) return 0;
    var parts = value.slice(open + 1, close).split(',');
    var x = parseFloat(parts.length > 6 ? parts[12] : parts[4]);
    return isNaN(x) ? 0 : x;
  }

  function attach(root) {
    var slidesEl = root.querySelector('.yg-hc__slides');
    var trackEl = root.querySelector('[data-yg-hc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-yg-hc-slide]'));
    if (!slidesEl || !trackEl || !slides.length) return null;

    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-yg-hc-bar]'));
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var duration = parseInt(root.getAttribute('data-duration'), 10) || 300;
    var fine = matches('(hover: hover) and (pointer: fine)');
    var mobileMq = window.matchMedia('(max-width: 749px)');
    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

    var current = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) current = i;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].classList.remove('is-active');
      slides[i].removeAttribute('aria-hidden');
    }

    var slotOf = [];
    for (i = 0; i < slides.length; i++) slotOf[i] = i;

    var timer = null;
    var settleTimer = null;
    var hidden = document.hidden;
    var inView = false;
    var fillAnim = null;
    var trackAnim = null;
    var slotAnims = [];
    var editorHold = false;
    var drawerHold = false;
    var moveId = 0;

    var dragging = false;
    var moved = false;
    var suppressClick = false;
    var dragPrepared = 0;
    var dragOrigin = 0;
    var dragAnchorX = 0;
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var downAt = 0;
    var pendingDx = 0;
    var moveRaf = 0;
    var activePointer = null;
    var lastClickMove = 0;
    var queuedClick = 0;
    var queueTimer = null;

    function span() {
      return slidesEl.offsetWidth || 1;
    }

    function nextIndex() {
      return (current + 1) % slides.length;
    }

    function prevIndex() {
      return (current - 1 + slides.length) % slides.length;
    }

    /* hero carousel - positions live in WAAPI holds, never in attributes */
    function setSlot(index, slot) {
      if (slotOf[index] === slot) return;
      slotOf[index] = slot;
      if (slotAnims[index]) slotAnims[index].cancel();
      var left = slot * 100 + '%';
      slotAnims[index] = slides[index].animate([{ left: left }, { left: left }], { duration: 0, fill: 'forwards' });
    }

    function translate(px) {
      return 'translate3d(' + px + 'px,0,0)';
    }

    function setTrack(px) {
      if (trackAnim) trackAnim.cancel();
      var value = translate(px);
      trackAnim = trackEl.animate([{ transform: value }, { transform: value }], { duration: 0, fill: 'forwards' });
    }

    function moveTrack(from, to) {
      if (trackAnim) trackAnim.cancel();
      var anim = trackEl.animate([{ transform: translate(from) }, { transform: translate(to) }], {
        duration: reduceMq.matches ? 0 : duration,
        easing: 'cubic-bezier(0.65, 0, 0.35, 1)',
        fill: 'forwards',
      });
      var id = moveId;
      anim.onfinish = function () {
        if (anim === trackAnim && id === moveId && !dragging) settle();
      };
      trackAnim = anim;
    }

    /* slots whose slide overlaps the viewport at track position x */
    function visibleRange(x) {
      var w = span();
      return {
        lo: Math.ceil((-w - x) / w + 0.000001),
        hi: Math.floor((w - x) / w - 0.000001),
      };
    }

    function videoAt(index) {
      var slide = slides[index];
      if (!slide) return null;
      var want = mobileMq.matches ? 'mobile' : 'desktop';
      return slide.querySelector(
        '[data-yg-hc-video="' + want + '"],[data-yg-hc-video="both"]'
      );
    }

    function warm(index) {
      var video = videoAt(index);
      if (!video) return;
      if (video.getAttribute('preload') === 'none') {
        video.setAttribute('preload', 'auto');
        video.load();
      }
    }

    function playAt(index) {
      var video = videoAt(index);
      if (!video) return;
      warm(index);
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }

    function pauseAt(index) {
      var video = videoAt(index);
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    function pauseAllIn(index) {
      var slide = slides[index];
      if (!slide) return;
      var all = slide.querySelectorAll('video');
      for (var i = 0; i < all.length; i++) {
        all[i].pause();
        try {
          all[i].currentTime = 0;
        } catch (e) {}
      }
    }

    function onBreakpoint() {
      for (var i = 0; i < slides.length; i++) pauseAllIn(i);
      playAt(current);
      warm(nextIndex());
    }

    function runBar(index) {
      if (fillAnim) fillAnim.cancel();
      fillAnim = null;
      var active = bars[index];
      var fill = active && active.firstElementChild;
      if (!fill || typeof fill.animate !== 'function') return;
      fillAnim = fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
        duration: interval,
        easing: 'linear',
        fill: 'forwards',
      });
    }

    function freezeBar() {
      if (fillAnim) fillAnim.pause();
    }

    function syncExposure() {
      for (var i = 0; i < slides.length; i++) {
        if (i === current) slides[i].removeAttribute('inert');
        else if (!slides[i].hasAttribute('inert')) slides[i].setAttribute('inert', '');
      }
    }

    function clearSettle() {
      if (settleTimer) {
        clearTimeout(settleTimer);
        settleTimer = null;
      }
    }

    /* reshuffle to slot 0 - only runs when current alone fills the viewport */
    function recenter() {
      var used = {};
      setSlot(current, 0);
      used[current] = true;

      var nx = nextIndex();
      if (!used[nx]) {
        setSlot(nx, 1);
        used[nx] = true;
      }
      var pv = prevIndex();
      if (!used[pv]) {
        setSlot(pv, -1);
        used[pv] = true;
      }

      var spare = 2;
      for (var i = 0; i < slides.length; i++) {
        if (!used[i]) setSlot(i, spare++);
      }
      setTrack(0);
    }

    function settle() {
      clearSettle();
      if (dragging) return;
      recenter();
      syncExposure();
      for (var i = 0; i < slides.length; i++) {
        if (i !== current) pauseAt(i);
      }
    }

    function armSettle() {
      clearSettle();
      var id = moveId;
      settleTimer = setTimeout(function () {
        if (id === moveId) settle();
      }, duration + 80);
    }

    /* every slide change starts here */
    function beginMove(target, back) {
      var x = currentX(trackEl);
      var vis = visibleRange(x);

      var slot;
      if (slotOf[target] >= vis.lo && slotOf[target] <= vis.hi) {
        slot = slotOf[target];
      } else {
        slot = back ? vis.lo - 1 : vis.hi + 1;
      }

      var spare = Math.max(vis.hi, slot) + 1;
      for (var i = 0; i < slides.length; i++) {
        if (i === target) continue;
        if (slotOf[i] >= vis.lo && slotOf[i] <= vis.hi) continue;
        setSlot(i, spare++);
      }
      setSlot(target, slot);

      current = target;
      moveId++;
      moveTrack(x, -slot * span());

      syncExposure();
      playAt(current);
      runBar(current);
      warm(nextIndex());
      armSettle();
    }

    function snapBack() {
      moveId++;
      moveTrack(currentX(trackEl), -slotOf[current] * span());
      runBar(current);
      armSettle();
    }

    function goTo(next, back) {
      if (next === current || !slides[next]) return;
      clearSettle();
      beginMove(next, back);
    }

    function advance() {
      goTo(nextIndex(), false);
      schedule();
    }

    function clear() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function schedule(delay) {
      clear();
      if (hidden || !inView || editorHold || drawerHold || dragging || slides.length < 2) return;
      timer = setTimeout(advance, delay == null ? interval : delay);
    }

    function halt() {
      clear();
      freezeBar();
      pauseAt(current);
    }

    function resume() {
      if (hidden || !inView || editorHold || drawerHold) return;
      playAt(current);
      runBar(current);
      schedule();
    }

    /* hero carousel - held in place under the mobile menu drawer */
    function holdForDrawer() {
      if (drawerHold) return;
      drawerHold = true;
      clear();
      freezeBar();
      var video = videoAt(current);
      if (video) video.pause();
    }

    function releaseForDrawer() {
      if (!drawerHold) return;
      drawerHold = false;
      if (hidden || !inView || editorHold || dragging) return;
      if (!fillAnim || fillAnim.playState !== 'paused') {
        resume();
        return;
      }
      var left = interval - (Number(fillAnim.currentTime) || 0);
      fillAnim.play();
      var video = videoAt(current);
      if (video && video.paused) {
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      }
      schedule(Math.max(0, left));
    }

    function onVisibility() {
      hidden = document.hidden;
      if (hidden) halt();
      else resume();
    }

    /* hero carousel - off screen pause */
    var observer = new IntersectionObserver(function (entries) {
      var next = entries[entries.length - 1].isIntersecting;
      if (next === inView) return;
      inView = next;
      if (inView) {
        resume();
      } else {
        clearQueue();
        halt();
      }
    });

    /* leading-edge preload, once per direction - a load() mid-gesture hitches */
    function prepare(dir) {
      if (dragPrepared === dir) return;
      dragPrepared = dir;

      var x = currentX(trackEl);
      var vis = visibleRange(x);
      var want = dir === 1 ? vis.hi + 1 : vis.lo - 1;
      var who = dir === 1 ? nextIndex() : prevIndex();

      if (slotOf[who] === want) return;
      if (slotOf[who] >= vis.lo && slotOf[who] <= vis.hi) return;

      for (var i = 0; i < slides.length; i++) {
        if (i === who || slotOf[i] !== want) continue;
        if (slotOf[i] >= vis.lo && slotOf[i] <= vis.hi) return;
        setSlot(i, want + dir * slides.length);
      }
      setSlot(who, want);
    }

    /* now known to be a drag - take over the running transition */
    function confirmDrag(event) {
      clearQueue();
      clearSettle();
      dragOrigin = currentX(trackEl);
      setTrack(dragOrigin);
      dragAnchorX = event.clientX;
    }

    function paintDrag() {
      moveRaf = 0;
      if (!dragging) return;
      setTrack(dragOrigin + pendingDx);
    }

    function detach() {
      if (moveRaf) {
        cancelAnimationFrame(moveRaf);
        moveRaf = 0;
      }
      try {
        if (activePointer !== null) slidesEl.releasePointerCapture(activePointer);
      } catch (e) {}
      activePointer = null;
    }

    function onPointerDown(event) {
      suppressClick = false;
      if (event.button != null && event.button !== 0) return;
      if (event.target.closest && event.target.closest('a, button')) return;
      if (slides.length < 2) return;

      clear();

      dragging = true;
      moved = false;
      dragPrepared = 0;
      pendingDx = 0;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      downAt = Date.now();

      freezeBar(current);
      activePointer = event.pointerId;
      try {
        slidesEl.setPointerCapture(event.pointerId);
      } catch (e) {}
    }

    function onPointerMove(event) {
      if (!dragging) return;

      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (!moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        /* 45 degree lock: a mostly-vertical gesture belongs to the page */
        if (Math.abs(dy) > Math.abs(dx)) {
          dragging = false;
          detach();
          schedule();
          return;
        }
        moved = true;
        confirmDrag(event);
      }

      prepare(dx < 0 ? 1 : -1);

      lastX = event.clientX;
      pendingDx = event.clientX - dragAnchorX;
      if (!moveRaf) moveRaf = requestAnimationFrame(paintDrag);
    }

    function release(cancelled) {
      if (!dragging) return;
      dragging = false;
      detach();

      if (!moved) {
        schedule();
        return;
      }

      var dx = lastX - startX;
      var travelled = Math.abs(dx);

      /* under the slop this was a click that drifted - let onClick navigate */
      if (travelled <= TAP_SLOP) {
        snapBack();
        schedule();
        return;
      }

      suppressClick = true;

      var far = travelled > span() * COMMIT_RATIO;
      var quick = Date.now() - downAt < QUICK_MS;

      if (!cancelled && (far || quick)) {
        beginMove(dx < 0 ? nextIndex() : prevIndex(), dx > 0);
      } else {
        snapBack();
      }
      schedule();
    }

    function onPointerUp() {
      release(false);
    }

    function onPointerCancel() {
      release(true);
    }

    function onLostCapture() {
      release(true);
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    /* click-driven advances only; drag and autoplay stay unthrottled */
    function clickCooldown() {
      return duration + COOLDOWN_BUFFER;
    }

    function clearQueue() {
      queuedClick = 0;
      if (queueTimer) {
        clearTimeout(queueTimer);
        queueTimer = null;
      }
    }

    function runClickMove(back) {
      lastClickMove = Date.now();
      clear();
      goTo(back ? prevIndex() : nextIndex(), back);
      schedule();
    }

    function requestClickMove(back) {
      var waited = Date.now() - lastClickMove;
      var window_ = clickCooldown();
      if (waited >= window_) {
        runClickMove(back);
        return;
      }
      /* at most one held; a later click replaces it so the newest direction wins */
      queuedClick = back ? -1 : 1;
      if (queueTimer) return;
      queueTimer = setTimeout(function () {
        queueTimer = null;
        var held = queuedClick;
        queuedClick = 0;
        if (held) runClickMove(held === -1);
      }, window_ - waited);
    }

    function onClick(event) {
      if (suppressClick) {
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (!fine || slides.length < 2) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (event.target.closest && event.target.closest('a, button')) return;

      var rect = slidesEl.getBoundingClientRect();
      var back = event.clientX - rect.left < rect.width / 2;
      requestClickMove(back);
    }

    /* the track position is in px, so a resize invalidates it */
    function onResize() {
      if (dragging) return;
      settle();
    }

    slidesEl.addEventListener('dragstart', onDragStart);
    slidesEl.addEventListener('pointerdown', onPointerDown);
    slidesEl.addEventListener('pointermove', onPointerMove);
    slidesEl.addEventListener('pointerup', onPointerUp);
    slidesEl.addEventListener('pointercancel', onPointerCancel);
    slidesEl.addEventListener('lostpointercapture', onLostCapture);
    slidesEl.addEventListener('click', onClick);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('resize', onResize);
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onBreakpoint);

    recenter();
    syncExposure();
    warm(nextIndex());
    observer.observe(root);

    return {
      root: root,
      holdForDrawer: holdForDrawer,
      releaseForDrawer: releaseForDrawer,
      selectSlide: function (element) {
        var index = slides.indexOf(element);
        if (index < 0) return;
        editorHold = true;
        clear();
        goTo(index, index < current);
        freezeBar(index);
      },
      releaseSlide: function () {
        editorHold = false;
        resume();
      },
      destroy: function () {
        observer.disconnect();
        clear();
        clearQueue();
        if (fillAnim) fillAnim.cancel();
        dragging = false;
        settle();
        detach();
        if (trackAnim) trackAnim.cancel();
        for (var k = 0; k < slotAnims.length; k++) if (slotAnims[k]) slotAnims[k].cancel();
        slidesEl.removeEventListener('dragstart', onDragStart);
        slidesEl.removeEventListener('pointerdown', onPointerDown);
        slidesEl.removeEventListener('pointermove', onPointerMove);
        slidesEl.removeEventListener('pointerup', onPointerUp);
        slidesEl.removeEventListener('pointercancel', onPointerCancel);
        slidesEl.removeEventListener('lostpointercapture', onLostCapture);
        slidesEl.removeEventListener('click', onClick);
        document.removeEventListener('visibilitychange', onVisibility);
        window.removeEventListener('resize', onResize);
        if (mobileMq.removeEventListener) {
          mobileMq.removeEventListener('change', onBreakpoint);
        }
        for (var i = 0; i < slides.length; i++) pauseAllIn(i);
      },
    };
  }

  /* hero carousel - mobile menu drawer watch */
  var DRAWER = '.header__drawer--mobile details.menu-drawer-container';
  var drawerCovering = false;
  var drawerScope = null;
  var drawerObserver = null;

  function setDrawer(next) {
    if (next === drawerCovering) return;
    drawerCovering = next;
    for (var id in instances) {
      if (next) instances[id].holdForDrawer();
      else instances[id].releaseForDrawer();
    }
  }

  function onDrawerMutation(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var el = record.target;
      if (!el.matches || !el.matches(DRAWER)) continue;
      if (!el.hasAttribute('open')) setDrawer(false);
      else if (record.attributeName === 'open' || el.classList.contains('menu-open')) setDrawer(true);
      else if ((' ' + (record.oldValue || '') + ' ').indexOf(' menu-open ') >= 0) setDrawer(false);
    }
  }

  function bindDrawer() {
    var drawer = document.querySelector(DRAWER);
    var scope = drawer && (drawer.closest('.shopify-section') || drawer.parentNode);
    if (!scope || (scope === drawerScope && scope.isConnected)) return;
    if (drawerObserver) drawerObserver.disconnect();
    drawerScope = scope;
    drawerObserver = new MutationObserver(onDrawerMutation);
    drawerObserver.observe(scope, {
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['open', 'class'],
    });
    setDrawer(drawer.hasAttribute('open') && drawer.classList.contains('menu-open'));
  }

  function init() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionId = root.getAttribute('data-section-id');
      if (!sectionId || instances[sectionId]) continue;

      var controller = attach(root);
      if (!controller) continue;
      instances[sectionId] = controller;
      if (drawerCovering) controller.holdForDrawer();
    }
    if (roots.length) bindDrawer();
  }

  function instanceFor(event) {
    var sectionId = event.detail && event.detail.sectionId;
    return sectionId ? instances[sectionId] : null;
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId || !instances[sectionId]) return;
    instances[sectionId].destroy();
    delete instances[sectionId];
  });

  document.addEventListener('shopify:block:select', function (event) {
    var instance = instanceFor(event);
    if (!instance || !event.target) return;
    var slide = event.target.closest('[data-yg-hc-slide]');
    if (slide) instance.selectSlide(slide);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var instance = instanceFor(event);
    if (instance) instance.releaseSlide();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
